import React, { ChangeEvent, Component } from 'react';
import { InputGroup, FormControl, FormControlProps, Button } from 'react-bootstrap';
import ConfigurationStore from '../stores/ConfigurationStore';
import { INotificationTypeField } from '../models/NotificationType';
import { observer } from 'mobx-react';
import validate from 'validator';

interface INotificationTypeFieldGroupProps {    
    field : INotificationTypeField,
    configurationStore : ConfigurationStore,
    disabled : boolean,
    setIsEditing : (isEditing : boolean) => void,
    cancelAdd : () => void
}

interface INotificationTypeFieldGroupState {
    isEditing : boolean,
    name : string
}

type NotificationTypeFieldGroupProps = INotificationTypeFieldGroupProps & FormControlProps;

@observer
class NotificationTypeFieldGroup extends Component<NotificationTypeFieldGroupProps, INotificationTypeFieldGroupState>  {
    state = {
        isEditing: false,
        name: this.props.field.name
    };

    constructor(props : NotificationTypeFieldGroupProps) {
        super(props);
        if (props.field.isNewField) {
            props.setIsEditing(true);
            this.state = {
                isEditing: true,
                name: ''
            };
        }
    }

    toggleEditing = () => {
        if(this.props.disabled)
            return;
        this.props.setIsEditing(true);
        this.setState({ isEditing: !this.state.isEditing});
    };

    save = () => {
        if(validate.isEmpty(this.props.field.name))
            return;
        this.props.configurationStore.updateNotificationType();
        this.props.setIsEditing(false);
        this.setState({ isEditing: false });
    };

    cancel = () => {
        this.props.setIsEditing(false);
        this.setState({ isEditing: false });
        this.props.cancelAdd();
    }

    setName = (event : ChangeEvent<EventTarget>) => {
        const target = event.target as HTMLInputElement;
        this.props.field.setName(target.value);
    };

    render() {
        return (
            <div>
                <InputGroup className='name col-sm-3 mb-3'>
                    <FormControl type='text' value={this.props.field.name} onChange={this.setName} readOnly={!this.state.isEditing}/>
                    {
                        this.state.isEditing ?
                        <InputGroup.Addon className='btn' onClick={this.save}>Save</InputGroup.Addon> :
                        <InputGroup.Addon className='btn dark' disabled={this.props.disabled} onClick={this.toggleEditing}>Edit</InputGroup.Addon>
                    }
                </InputGroup>
                {
                    this.state.isEditing && <Button bsStyle='danger' onClick={this.cancel}>Cancel</Button>
                }
            </div>
        )
    }
};

export { 
    NotificationTypeFieldGroup
}